import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {  numberFormat } from '../../../../redux/config/config';
import { green } from '@material-ui/core/colors';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Icon
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import mockData from './data';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const statusColors = {
  delivered: 'success',
  pending: 'info',
  refunded: 'danger'
};

const LatestOrders = props => {
  const { className, users, loading, ...rest } = props;

  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [orders] = useState(mockData);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader
        title="Latest Transactions"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={4}>Name</TableCell>
                  <TableCell colSpan={4}>Amount</TableCell>
                  <TableCell colSpan={4}>Transaction Type</TableCell>
                  <TableCell colSpan={4}>Transaction Category</TableCell>
                  <TableCell colSpan={4}>Paystack ID</TableCell>
                  <TableCell colSpan={4}>Payment Method</TableCell>
                  <TableCell colSpan={4}>Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {loading?
              <TableRow><TableCell><CircularProgress /></TableCell></TableRow>:
              users && users.length !== 0 ?
                users.slice(page * rowsPerPage, page* rowsPerPage + rowsPerPage).map(user => (
                 <TableRow
                    className={classes.tableRow}
                    hover
                    key={user.id}
                  >
                    <TableCell colSpan={4}>{user.first_name + " " + user.last_name}</TableCell>
                    <TableCell colSpan={4}>{numberFormat(user.amount)}</TableCell>
                    <TableCell style={{color:user.transaction_type === "credit"?"green":"red"}} colSpan={4}>{user.transaction_type}</TableCell>
                    <TableCell colSpan={4}>
                      {user.transaction_category === 1 ? "Regular Savings": 
                      (user.transaction_category === 2) ? "Target Savings":
                      (user.transaction_category === 3) ? "Share Holding":
                      (user.transaction_category === 4) ? "Loan":
                      (user.transaction_category === 5) ? "Market Investment":
                      (user.transaction_category === 6) ? "Business Financing":
                      (user.transaction_category === 7) ? 
                      (user.transaction_type === "credit")?"Wallet Funding":" Wallet Withdrawal": ""}
                    </TableCell>
                    <TableCell colSpan={4}>{user.paystack_id}</TableCell>
                    <TableCell colSpan={4}>{user.payment_method}</TableCell>
					<TableCell colSpan={4}>
                      {moment(user.entry_date).format('DD/MM/YYYY')}
                    </TableCell>
                  </TableRow>
                )):
                <TableRow>
                <TableCell colSpan="7" style={{textAlign:"center"}}>
                    No Record Found
                </TableCell>                
                </TableRow>
                }
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={users && users.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
      <Divider />
      <CardActions className={classes.actions}>
        <Link to="/transactions">
          <Button
            color="primary"
            size="small"
            variant="text">
            View all <ArrowRightIcon />
          </Button>
        </Link>
      </CardActions>
    </Card>
  );
};

LatestOrders.propTypes = {
  className: PropTypes.string
};

export default LatestOrders;
